export default "__VITE_ASSET__0d9b513f__"